import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";

export default function Pricing() {
  const scrollToContact = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <Wrapper id="get-started">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Experience the future of legal practice</h1>
            <p className="font13">
              Click Law is the digital backbone of modern legal practice. Take the next step—schedule a demonstration, explore Click Companion, or start modernising your firm.
            </p>
          </HeaderInfo>
          <CardsWrapper className="flexSpaceNull">
            <CtaCard>
              <h4 className="font20 extraBold">Demo</h4>
              <p className="font13" style={{ margin: "20px 0" }}>
                See the platform in action. We&apos;ll walk you through case management, legal research, and Click Companion AI with a tailored demo.
              </p>
              <FullButton title="Demo" action={scrollToContact} />
            </CtaCard>
            <CtaCard>
              <h4 className="font25 extraBold">Companion</h4>
              <p className="font13" style={{ margin: "20px 0" }}>
                Meet your AI legal assistant. Click Companion helps lawyers search authorities faster, analyse legal questions, and amplify their expertise.
              </p>
              <FullButton title="Companion" action={() => { window.location.href = "/login"; }} />
            </CtaCard>
            <CtaCard>
              <h4 className="font25 extraBold">Modernise your firm</h4>
              <p className="font13" style={{ margin: "20px 0" }}>
                Join firms that run with clarity and efficiency. One secure platform for cases, documents, workflows, and legal intelligence.
              </p>
              <FullButton title="Modernise your firm" action={scrollToContact} />
            </CtaCard>
          </CardsWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: space-between;
  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
  }
`;
const CtaCard = styled.div`
  width: 31%;
  padding: 40px 30px;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 0 11px rgba(237, 232, 237, 0.5);
  text-align: left;

  /* Keep CTA cards readable in dark mode */
  h4 {
    color: #063922;
  }
  p {
    color: #063922;
  }

  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
  }
`;




